export default __webpack_public_path__ + "static/5-9bfc6e15905fa7a837a7d9327fd5111c.png";